export { VehicleCard } from "./vehicle-card";
